import React from 'react';
import PropTypes from 'prop-types';

const AlertView = (props) =>{

    return <div>

    </div>

};

AlertView.propTypes = {
    notification: PropTypes.object
};

export default AlertView;


// WEBPACK FOOTER //
// ./src/components/UserNotifications/Templates/Alert.js